import * as React from "react";

type Props = Omit<React.SVGProps<SVGSVGElement>, "width" | "height"> & {
  /** icon size in px (applies to both width & height) */
  size?: number;
  className?: string;
};

export const SparkleIcon = ({ size = 32, className, ...props }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <g clipPath="url(#clip0_2150_204163)">
      <path
        d="M10.5337 21.4664L3.64749 18.9289C3.45761 18.8588 3.29377 18.7322 3.17806 18.5662C3.06234 18.4001 3.00031 18.2026 3.00031 18.0002C3.00031 17.7978 3.06234 17.6002 3.17806 17.4342C3.29377 17.2681 3.45761 17.1415 3.64749 17.0714L10.5337 14.5339L13.0712 7.64767C13.1413 7.45779 13.2679 7.29396 13.434 7.17824C13.6 7.06253 13.7976 7.00049 14 7.00049C14.2024 7.00049 14.3999 7.06253 14.566 7.17824C14.732 7.29396 14.8587 7.45779 14.9287 7.64767L17.4662 14.5339L24.3525 17.0714C24.5424 17.1415 24.7062 17.2681 24.8219 17.4342C24.9376 17.6002 24.9997 17.7978 24.9997 18.0002C24.9997 18.2026 24.9376 18.4001 24.8219 18.5662C24.7062 18.7322 24.5424 18.8588 24.3525 18.9289L17.4662 21.4664L14.9287 28.3527C14.8587 28.5426 14.732 28.7064 14.566 28.8221C14.3999 28.9378 14.2024 28.9999 14 28.9999C13.7976 28.9999 13.6 28.9378 13.434 28.8221C13.2679 28.7064 13.1413 28.5426 13.0712 28.3527L10.5337 21.4664Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 2V8"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28 9V13"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 5H25"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 11H30"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2150_204163">
        <rect width={32} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
